import http from "@/api.js";

export default {
    name: 'folder-mixin',
    emits: ['folder-choice', 'folder-change', 'folder-child-change'],
    data: () => ({
        current_uid: "root",
        folder_init_uid: null,
        last_reload_folder: {},
        local_folders: [],
        folder_path: [],
        folderdata: {
            response: {},
            documents: [],
            folders: [],
            update: [],
        },
    }),
    props: {
        init_uid: { type: String, },
        folders: { type: Array, default: [] },
        reload_folder: { type: Object, default: null },
        update_folders: { type: Array, default: [] },
    },
    created(){
        this.local_folders = this.folders;
    },
    watch: {
        update_folders: {
            handler: function(){
                this.update_folders.forEach(f => {
                    console.log("update folder", f);
                    const idx = this.local_folders.findIndex(lf => lf.uid === f.uid);
                    if(idx > -1){
                        this.local_folders[idx] = f;
                    }
                });
            },
            deep: true,
        },
    },
    methods: {
        reloadParent(){ console.log('reloadParent need to be implement in view'); },
        reloadFolder(){ console.log('reloadFolder need to be implement in view'); },
        openFolder(){ console.log('openFOlder need to be implement in view'); },
        closeFolder(){ console.log('closeFolder need to be implement in view'); },
        loadOnNeedReloadFolder(){
            if(this.reload_folder.date && this.reload_folder.date != this.last_reload_folder?.date){
                this.reloadFolder(this.reload_folder.folder, false);
                this.last_reload_folder = this.reload_folder;
            }
        },
        //reloadFolder($event, propagate=true){
        //    const local_uids = this.folders.map(f => f.uid);
        //    if(this.dytHasUid($event) || local_uids.indexOf($event) > -1)
        //        this.openFolder($event, true)
        //    else if(propagate)
        //        this.$emit('folder-change', $event);
        //},
        folderPath(uid, folder){
            if(uid != 'root'){
                http.get(this.folderUrl(uid, "path_finder/")).then(response => {
                    this.folder_path = response.data.reverse();
                    this.folder_path.push(folder);
                });
            }else{
                this.folder_path = [];
            }
        },
        folderRootInit(uid){
            this.dytBusy(uid);
            http.get(this.folderUrl(uid)).then(response => {
                this.folderdata.response = response.data;
                if(!this.folder_init_uid)
                    this.folder_init_uid = response.data.uid;
                if(uid == "root"){
                    this.folderdata.folders = response.data;
                }else{
                    this.folderdata.folders = response.data.folders;
                    this.folderdata.documents = response.data.documents;
                }
                if(this.header || this.toolbar)
                    this.folderPath(this.folderdata?.response?.uid || uid, this.folderdata.response);
                this.dytBusy(uid);
                this.current_uid = uid;
            }).catch(error => {
                console.log(error);
                this.dytBusy(uid);
            });
        },
        // New folder
        startNewFolder(folder){
            this.dytUnfold(this.squeezeUid("newfolder", folder.uid));
            this.$nextTick(() => {
                var input = this.$refs[this.squeezeUid("newfolder", folder.uid)][0];
                input.value = "";
                input.focus();
            });
        },
        doNewFolder(folder){
            this.dytBusy(folder.uid);
            var input = this.$refs[this.squeezeUid("newfolder", folder.uid)][0];
            http.post("/api/"+this.$route.params.groupUid+this.folderapi, {name: input.value, parent: folder.uid}).then(() => {
                this.dytBusy(folder.uid);
                this.dytUnfold(this.squeezeUid("newfolder", folder.uid));
                this.reloadFolder(folder.uid);
            }).catch(() => {
                this.dytBusy(folder.uid);
            });
        },
        // Rename
        startRenameFolder(folder){
            this.dytUnfold(this.squeezeUid("rename", folder.uid));
            var input = this.$refs[this.squeezeUid("rename", folder.uid)][0];
            this.$nextTick(() => {
                input.value = folder.name;
                input.focus();
            });
        },
        doRenameFolder(folder){
            this.dytBusy(folder.uid);
            var input = this.$refs[this.squeezeUid("rename", folder.uid)][0];
            http.put(this.folderUrl(folder.uid), {name: input.value}).then(() => {
                folder.name = input.value;
                this.dytBusy(folder.uid);
                this.dytUnfold(this.squeezeUid("rename", folder.uid));
            }).catch(() => {
                this.dytBusy(folder.uid);
            });
        },
        // Remove
        startRemoveFolder(f){
            if (confirm("Etes vous sur de vouloir supprimer le dossier "+f.name+" ?")) {
                http.delete(this.folderUrl(f.uid)).then(() => {
                    this.reloadFolder(f.parent);
                });
            }
        },
        openContextualMenuFolder($event, folder){
            var menu = [];
            menu.push({ label: "Ouvrir/Fermer", function: () => this.openFolder(folder.uid) });
            menu.push({ label: "Ajouter un sous dossier", function: () => this.startNewFolder(folder) });
            menu.push({ label: "Ajouter un document", function: () => this.startUploadFiles(folder) });
            menu.push({ label: "Nouveau document", function: () => this.$emit("ask-create-document", folder) });
            if(folder.parent){
                menu.push({ label: "Renommer", function: () => this.startRenameFolder(folder) });
                menu.push({ label: "Supprimer", function: () => this.startRemoveFolder(folder) });
            }
            this.CtxMenuOpen($event, { menu });
        },
    }
}
